import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import MyContent from '@/components/MyContent'
import NewMedia from '@/components/NewMedia'
import BrandContent from '@/components/BrandContent'
import Screens from '@/components/Screens'
import ManageAccount from '@/components/Account'
import ScreenManage from '@/components/ScreenManage'
import AccountCreation from '@/components/AccountCreation'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root'
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/new-media',
      name: 'New-Media',
      component: NewMedia
    }, {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    }, {
      path: '/content',
      name: 'MyContent',
      component: MyContent
    }, {
      path: '/brand',
      name: 'BrandContent',
      component: BrandContent
    }, {
      path: '/screens',
      name: 'Screens',
      component: Screens
    }, {
      path: '/account',
      name: 'Account',
      component: ManageAccount
    }, {
      path: '/screenmanage',
      name: 'ScreenManage',
      component: ScreenManage
    }, {
      path: '/account-creation',
      name: 'Account-Creation',
      component: AccountCreation
    }
  ]
})
